<template>
  <div class="joinUs">
    <Header />
    <div class="banner">
      <div class="text">
        <p>加入我们</p>
        <span>和科云一起成长，创业艰辛，但进步看得见</span>
      </div>
    </div>
    <div class="content">
      <div class="job">加入我们</div>
      <!-- <div class="input">
        <el-select v-model="chooseJob" placeholder="请选择职业" class="choose">
          <el-option v-for="item in Job" :value="item.value" :label="item.label" :key="item.value"></el-option>
        </el-select>
        <el-input v-model="jobName" placeholder="请输入职位名称" class="job-name" />
        <el-button class="button">搜索</el-button>
      </div> -->
      <div class="input-2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-row>
            <el-col :span="11">
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入您的姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="公司规模">
                <el-input
                  v-model="ruleForm.companySize"
                  placeholder="请输入您的公司规模"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="电话" prop="telphone">
                <el-input
                  v-model="ruleForm.telphone"
                  placeholder="请输入您的电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="关注产品" prop="focus">
                <el-input
                  v-model="ruleForm.focus"
                  placeholder="请输入您所关注的产品"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="邮箱">
                <el-input
                  v-model="ruleForm.mailbox"
                  placeholder="请输入您的邮箱"
                ></el-input>
              </el-form-item>
              <br />
              <el-form-item label="公司" prop="company">
                <el-input
                  v-model="ruleForm.company"
                  placeholder="请输入您的公司"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="留言" prop="message" class="message">
                <el-input
                  type="textarea"
                  v-model="ruleForm.message"
                  placeholder="请输入您的留言"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="button" @click="submitForm('ruleForm')">提交</div>
      </div>
    </div>
    <div class="contactUs">
      <div class="contact">联系我们</div>
      <img src="../../../assets/img/about/joinsUs/207.png" class="img" />
      <p>联系电话：13520614030</p>
      <span>通讯地址：广州市天河区建工路南天大厦308</span>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import axios from "axios";
export default {
  components: { Header, Footer },
  data() {
    return {
      ruleForm: {
        name: "",
        companySize: "",
        telphone: "",
        focus: "",
        mailbox: "",
        message: "",
        company: ""
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        telphone: [
          { required: true, message: "请输入您的电话", trigger: "blur" }
        ],
        focus: [
          { required: true, message: "请输入您所关注的产品", trigger: "blur" }
        ],
        company: [
          { required: true, message: "请输入您的公司", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios({
            url: "http://show.keyunshop.com/oper_mng/txCtrl?txcode=com016",
            method: "post",
            data: {
              name: this.ruleForm.name,
              companySize: this.ruleForm.companySize,
              telphone: this.ruleForm.telphone,
              focus: this.ruleForm.focus,
              mailbox: this.ruleForm.mailbox,
              message: this.ruleForm.message,
              company: this.ruleForm.company
            }
          }).then(res => {
            console.log("请求结果：", res.data.data.result_code);
            if (res.data.data.result_code == "1") {
              this.$message.success("提交成功！感谢您");
              this.$refs[formName].resetFields();
              this.ruleForm.message = "";
              this.ruleForm.companySize = "";
              this.ruleForm.mailbox = "";
            } else {
              this.$message.error(res.data.data.msg);
            }
          });
        } else {
          this.$message.error("请把必填项填写完成之后再提交");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.joinUs {
  .banner {
    box-sizing: border-box;
    height: 444px;
    padding-top: 140px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 100%;
    background-image: url("../../../assets/img/about/joinsUs/216.png");

    .text {
      p {
        height: 62px;
        font-size: 44px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 62px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
      span {
        margin-top: 14px;
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
    }
  }
  .content {
    .job {
      margin-top: 120px;
      margin-bottom: 61px;
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .input {
      margin-bottom: 330px;

      .choose {
        box-sizing: border-box;
        width: 460px;
        height: 42px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(62, 113, 255, 1);
        opacity: 1;
        border-radius: 2px;
      }
      .job-name {
        margin: 0 40px 0 20px;
        box-sizing: border-box;
        width: 440px;
        height: 42px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(217, 220, 229, 1);
        opacity: 1;
        border-radius: 2px;
      }
      .button {
        box-sizing: border-box;
        width: 240px;
        height: 42px;
        border: 0;
        background: rgba(62, 113, 255, 1);
        opacity: 1;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
        cursor: pointer;
      }
    }
    .input-2 {
      padding: 80px 80px 0 80px;
      box-sizing: border-box;
      width: 1200px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 9px 20px rgba(41, 43, 58, 0.1);
      opacity: 1;
      border-radius: 4px;

      .button {
        margin: 60px 0 54px 0;
        display: inline-block;
        width: 140px;
        height: 38px;
        background: rgba(62, 113, 255, 1);
        box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
        opacity: 1;
        border-radius: 19px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
        cursor: pointer;
      }
    }
  }
  .contactUs {
    .contact {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
      box-sizing: border-box;
      height: 222px;
      padding: 120px 0 60px 0;
    }
    .img {
      width: 1200px;
      height: 580px;
    }
    p {
      margin: 50px 0 15px 0;
      height: 25px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    span {
      margin-bottom: 183px;
      display: inline-block;
      height: 25px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
  }
}
</style>
<style scoped>
.choose >>> .el-input__inner {
  height: 42px;
  outline: none;
}
.job-name >>> .el-input__inner {
  height: 42px;
  outline: none;
}
.message >>> .el-textarea__inner {
  min-height: 129px !important;
}
</style>
